import request from '@/utils/request'

// 获取路由
export const getRouters = () => {
  return request({
    url: '/system/menu/getRouters',
    method: 'get'
  })
}
// 新增统计后台页面点击情况
export function statistics(data) {
  return request({
    url: '/system/statistics',
    method: 'post',
    data: data
  })
}
